<template>
  <div>
    <div class="form-container" style="padding: 0">
      <el-form inline size="mini" label-width="140px" disabled :model="conditions">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="是否配额酒">
              <el-select
                v-model="conditions.ispej"
                placeholder="请选择"
              >
                <el-option label="是" value="X" />
                <el-option label="否" value="" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额内外比例（内）">
              <el-input v-model="conditions.nrate" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额内外比例（外）">
              <el-input v-model="conditions.wrate" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额控制周期">
              <el-select v-model="conditions.pecycle" clearable>
                <el-option label="月" value="Z001" />
                <el-option label="季度" value="Z002" />
                <el-option label="年" value="Z003" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prod: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      conditions: {
        ispej: '',
        wrate: '',
        pecycle: '',
        nrate: ''
      }
    }
  },
  created() {
    for (const key in this.conditions) {
      this.conditions[key] = this.prod[key]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/product-manage/components/QuotaInfoCheck.vue